import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=652284f8"
import script from "./alert.js?vue&type=script&lang=js&external"
export * from "./alert.js?vue&type=script&lang=js&external"
import style0 from "./alert.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports